import CbBox from './src/box.vue';

CbBox.install = function(Vue) {
  Vue.component(CbBox.name, CbBox);
};

export default CbBox;
